/* ===========================================
   Klaro! configuration – collectibleshunters.it
   (GA4 + Meta Pixel con consenso esplicito)
   =========================================== */
(function () {
  // helper per caricare script in modo asincrono
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.async = true;
      s.src = src;
      s.onload = res;
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  // assicurati che il dataLayer esista sempre
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){ dataLayer.push(arguments); };

  window.klaroConfig = {
  version: 1,                  // ↑ aumenta a 2 SOLO quando cambi davvero la config
  elementID: 'klaro',
  styling: { theme: ['light','bottom'] },
  groupByPurpose: true,

  // ✅ Persistenza del consenso (scelta consigliata)
  storageMethod: 'localStorage',

  // (Se preferisci i cookie, usa questi invece di localStorage)
  // storageMethod: 'cookie',
  // cookieName: 'klaro',
  // cookieExpiresAfterDays: 180,
  // cookieDomain: '.collectibleshunters.it', // include il punto iniziale
  // cookiePath: '/',

  // Comportamento
  mustConsent: false,
  acceptAll: true,
  hideDeclineAll: false,
  default: false,

  purposes: ['essential','analytics','marketing'],

  // …lascia qui sotto TUTTO invariato (translations, services, ecc.)


    translations: {
      it: {
        consentNotice: {
          description: 'Usiamo cookie per migliorare la tua esperienza e per fini statistici e di marketing. Puoi scegliere cosa attivare.',
          learnMore: 'Impostazioni'
        },
        consentModal: {
          title: 'Preferenze cookie',
          description: 'Seleziona le finalità dei cookie che desideri abilitare. Puoi modificare la scelta in qualsiasi momento.'
        },
        ok: 'Accetta tutti',
        acceptAll: 'Accetta tutti',
        decline: 'Rifiuta',
        save: 'Salva preferenze',
        purposes: {
          essential: 'Necessari',
          analytics: 'Statistiche',
          marketing: 'Marketing'
        },
        privacyPolicy: {
          name: 'Cookie Policy',
          text: 'Per maggiori informazioni, consulta la nostra {privacyPolicy}.',
          url: '/policies/cookie-policy'
        }
      },
      en: {
        consentNotice: {
          description: 'We use cookies to improve your experience and for analytics/marketing. Choose what to enable.',
          learnMore: 'Settings'
        },
        consentModal: {
          title: 'Cookie preferences',
          description: 'Select which purposes you allow. You can change your choice at any time.'
        },
        ok: 'Accept all',
        acceptAll: 'Accept all',
        decline: 'Reject',
        save: 'Save preferences',
        purposes: {
          essential: 'Essential',
          analytics: 'Analytics',
          marketing: 'Marketing'
        },
        privacyPolicy: {
          name: 'Cookie Policy',
          text: 'For more info, see our {privacyPolicy}.',
          url: '/policies/cookie-policy'
        }
      }
    },

    services: [
      /* ====================== NECESSARI (sempre attivi) ====================== */
      {
        name: 'shopify-core',
        title: 'Funzioni tecniche del negozio',
        purposes: ['essential'],
        required: true,
        default: true,
        // elenco indicativo dei tecnici tipici di Shopify
        cookies: [
          /^cart/, 'cart', 'cart_currency', 'cart_sig', 'cart_ts',
          'localization', '_orig_referrer', '_landing_page', 'secure_customer_sig'
        ]
      },

      /* ===================== GOOGLE ANALYTICS 4 (Statistiche) ===================== */
      {
        name: 'google-analytics',
        title: 'Google Analytics 4',
        purposes: ['analytics'],
        required: false,
        default: false,
        cookies: [/^_ga/, /^_ga_/, /^_gid/, /^_gat/],
        callback: async function (consent) {
          // aggiorna la Google Consent Mode SOLO per analytics
          gtag('consent','update', { analytics_storage: consent ? 'granted' : 'denied' });

          if (!consent) return; // non caricare se l'utente ha rifiutato

          // ---- CONFIGURA IL TUO ID GA4 QUI ----
          var GA4_ID = 'G-7D6JEL7654';
          // -------------------------------------

          if (!window.__ga4Loaded) {
            window.__ga4Loaded = true;
            await loadScript('https://www.googletagmanager.com/gtag/js?id=' + GA4_ID);
            gtag('js', new Date());
            gtag('config', GA4_ID, { anonymize_ip: true });
          }
        }
      },

      /* ======================= META / FACEBOOK (Marketing) ======================= */
      {
        name: 'facebook-pixel',
        title: 'Meta Pixel',
        purposes: ['marketing'],
        required: false,
        default: false,
        cookies: ['_fbp','fr'],
        callback: function (consent) {
          // aggiorna anche la Consent Mode per la parte advertising
          gtag('consent','update', {
            ad_storage: consent ? 'granted' : 'denied',
            ad_user_data: consent ? 'granted' : 'denied',
            ad_personalization: consent ? 'granted' : 'denied'
          });

          if (!consent) {
            if (window.fbq) { try { fbq('consent','revoke'); } catch(e){} }
            return;
          }

          // ---- CONFIGURA IL TUO PIXEL ID QUI ----
          var FB_PIXEL_ID = '12282982538';
          // ---------------------------------------

          if (!window.__fbLoaded) {
            window.__fbLoaded = true;
            !function (f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){
              n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
              s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', FB_PIXEL_ID);
          }
          fbq('consent','grant');
          fbq('track','PageView');
        }
      }

      // Se usi TikTok, aggiungi un blocco simile a Meta e mappa su "marketing".
    ]
  };
})();
